import { render, staticRenderFns } from "./courseHourResourceContent.vue?vue&type=template&id=169d26e0&scoped=true"
import script from "./courseHourResourceContent.vue?vue&type=script&lang=js"
export * from "./courseHourResourceContent.vue?vue&type=script&lang=js"
import style0 from "./courseHourResourceContent.vue?vue&type=style&index=0&id=169d26e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169d26e0",
  null
  
)

export default component.exports